import { render, staticRenderFns } from "./MainCoin.vue?vue&type=template&id=4658eb8d&scoped=true&"
import script from "./MainCoin.vue?vue&type=script&lang=js&"
export * from "./MainCoin.vue?vue&type=script&lang=js&"
import style0 from "./MainCoin.vue?vue&type=style&index=0&id=4658eb8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4658eb8d",
  null
  
)

export default component.exports